import { GateOrIcon } from './GateOrIcon';

/**
 * author: Nick
 * id 13B88427-8795-48CF-B647-597997C6C541
 * name gate-or
 * version: 2.3.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/gate-or.svg
 * tags
 */
export const LogicGateOrIcon = GateOrIcon;
export default LogicGateOrIcon